export const MAXIMUM_VOLUME_SYSTEM_NAME_LENGTH = 32;
export const MINIMUM_VOLUME_SYSTEM_NAME_LENGTH = 1;
export const MINIMUM_VOLUME_SYSTEM_LEVEL_VALUE = 0;
export const MAXIMUM_VOLUME_SYSTEM_LEVEL_VALUE = 999999.99;
